@if (!avatar()) {
  <div class="letter">{{name() | slice:0:1}}</div>
}
